import React, { useState } from "react";

const Contatti = () => {
  const [formData, setFormData] = useState({
    nome: '',
    messaggio: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Crea il messaggio WhatsApp precompilato
    const message = `Ciao, sono ${formData.nome}. ${formData.messaggio}`;
    
    // Crea l'URL WhatsApp
    const whatsappURL = `https://wa.me/393458279163?text=${encodeURIComponent(message)}`;
    
    // Apri WhatsApp in una nuova finestra
    window.open(whatsappURL, '_blank');
    
    // Reset del form
    setFormData({ nome: '', messaggio: '' });
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-sage-light to-beige-light">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/images/contatti-hero.jpg')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '60% 35%'
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-title font-bold text-white mb-6">
              Contatti
            </h1>
            <p className="text-lg md:text-2xl font-body text-white max-w-3xl mx-auto">
              Sono qui per rispondere alle tue domande e personalizzare la tua esperienza
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-title font-bold text-sage-dark mb-8">
                SCRIVIMI SU WHATSAPP
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-neutral-700 mb-2">
                    Nome e Cognome *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-neutral-300 rounded-xl focus:ring-2 focus:ring-sage-light focus:border-sage-light transition-colors"
                    placeholder="Il tuo nome completo"
                  />
                </div>

                <div>
                  <label htmlFor="messaggio" className="block text-sm font-medium text-neutral-700 mb-2">
                    Messaggio *
                  </label>
                  <textarea
                    id="messaggio"
                    name="messaggio"
                    value={formData.messaggio}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-4 py-3 border border-neutral-300 rounded-xl focus:ring-2 focus:ring-sage-light focus:border-sage-light transition-colors resize-none"
                    placeholder="Descrivi la tua richiesta o domanda..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-sage-dark hover:bg-sage-medium text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105"
                >
                  Apri WhatsApp
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div>
              <h2 className="text-3xl font-title font-bold text-sage-dark mb-8">
                Informazioni di Contatto
              </h2>
              
              <div className="space-y-8">
                {/* Direct Contact */}
                <div className="bg-beige-light rounded-3xl p-6">
                  <h3 className="text-xl font-title font-semibold text-sage-dark mb-4">
                    Contatto Diretto
                  </h3>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <svg className="w-6 h-6 text-sage-dark mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <span className="font-body text-neutral-700">+39 3458279163</span>
                    </div>
                    <div className="flex items-center">
                      <svg className="w-6 h-6 text-sage-dark mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span className="font-body text-neutral-700">cattaneoroberto.9@gmail.com</span>
                    </div>
                  </div>
                </div>

                {/* Hours */}
                <div className="bg-beige-light rounded-3xl p-6">
                  <h3 className="text-xl font-title font-semibold text-sage-dark mb-4">
                    Orari di Contatto
                  </h3>
                  <div className="space-y-2 font-body text-neutral-700">
                    <p><strong>Lunedì - Venerdì:</strong> 9:00 - 18:00</p>
                    <p><strong>Sabato:</strong> 9:00 - 13:00</p>
                    <p><strong>Domenica:</strong> Chiuso</p>
                  </div>
                </div>

                {/* Social Media */}
                <div className="bg-beige-light rounded-3xl p-6">
                  <h3 className="text-xl font-title font-semibold text-sage-dark mb-4">
                    Seguici sui Social
                  </h3>
                  <div className="flex space-x-4">
                    <a 
                      href="https://www.facebook.com/share/1Dtmr2Li8Q/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-sage-dark hover:bg-sage-medium text-white rounded-full flex items-center justify-center transition-colors"
                      aria-label="Facebook"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </a>
                    <a 
                      href="https://www.instagram.com/acquolina_acasatua?igsh=MXBvN25nend2bWRhbg=="
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-sage-dark hover:bg-sage-medium text-white rounded-full flex items-center justify-center transition-colors"
                      aria-label="Instagram"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contatti;